import {
  Component,
  HostListener,
  OnInit,
  Inject,
  PLATFORM_ID
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Stockitem } from '../../../../interfaces/stockitem';
import { CartService } from '../../../../services/cart';
import { AdvancedStocksService } from '../../../../services/advancedstocksservice';
import { DeviceDetectorService } from '../../../../services/device-detector.service';
import { isPlatformBrowser } from '@angular/common';

@Component({
  selector: 'app-productsbycatagory',
  templateUrl: './productsbycatagory.component.html',
  styleUrl: './productsbycatagory.component.scss'
})
export class ProductsbycatagoryComponent implements OnInit {

  allData: Stockitem[] = [];
  totalItems = 0;
  stockTotal: any;

  contentReady = true;
  noData = false;
  searched = false;

  page = 1;
  itemCount = 9;

  isAr = false;
  isMobile = false;

  catid!: any;
  catagoryId?: any;
  price?: any;
  searchKey = '';

  showRejectPopUp = false;
  cartPopUp = false;

  private isBrowser: boolean;

  constructor(
    private router: Router,
    private deviceService: DeviceDetectorService,
    private _advancedStocks: AdvancedStocksService,
    private cartService: CartService,
    private activatedRoute: ActivatedRoute,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {
    this.isBrowser = isPlatformBrowser(this.platformId);
  }

  ngOnInit(): void {

    // ⛔ SSR يقف هنا
    if (!this.isBrowser) {
      return;
    }

    // Browser only
    this.isMobile = this.deviceService.isMobileDevice();
    this.itemCount = this.isMobile ? 8 : 9;
    this.isAr = localStorage.getItem('language') === 'ar';

    this.activatedRoute.params.subscribe(params => {
      this.catid = params['id'];
      this.page = 1;

      if (this.catid) {
        this.getProductsByPet(this.catid);
      }
    });
  }

  // ================= FILTERS =================
  underPrice(price: any): void {
    this.price = price;
    this.page = 1;
    this.getProductsByPet(this.catid);
  }

  getProductsByPetAndCatagory(catagoryId: any): void {
    this.catagoryId = catagoryId;
    this.page = 1;
    this.getProductsByPet(this.catid);
  }

  // ================= DATA =================
  getProductsByPet(petId: any): void {

    this.contentReady = true;
    this.searched = false;

    this._advancedStocks
      .advancedStocks(
        1,
        this.page,
        this.itemCount,
        {
          categoryId: this.catagoryId ?? petId,
          maxPrice: this.price
        }
      )
      .subscribe({
        next: (res: any) => {
          this.allData = res.data;
          this.stockTotal = res.meta.total;
          this.totalItems = res.meta.last_page;

          this.noData = this.stockTotal === 0;
          this.contentReady = false;
        },
        error: (error) => {
          console.error(error);
          this.contentReady = false;
          this.noData = true;
        },
      });
  }

  // ================= INFINITE SCROLL =================
  @HostListener('window:scroll', [])
  onWindowScroll(): void {

    if (!this.isBrowser || this.contentReady || this.searchKey !== '') return;

    const scrollPosition =
      window.pageYOffset ||
      document.documentElement.scrollTop ||
      document.body.scrollTop ||
      0;

    const windowHeight = window.innerHeight;
    const pageHeight = document.documentElement.scrollHeight;

    const bottomReached =
      scrollPosition + windowHeight >= pageHeight - 10;

    if (this.page === 1) {
      this.page = 2;
    }

    if (bottomReached && this.page <= this.totalItems) {
      this.loadMore();
    }
  }

  private loadMore(): void {
    this.contentReady = true;

    this._advancedStocks
      .advancedStocks(
        1,
        this.page,
        this.itemCount,
        {
          categoryId: this.catagoryId ?? this.catid,
          maxPrice: this.price
        }
      )
      .subscribe({
        next: (res: any) => {
          this.allData = [...this.allData, ...res.data];
          this.page++;
          this.noData = this.allData.length === 0;
          this.contentReady = false;
        },
        error: (error) => {
          console.error(error);
          this.contentReady = false;
        },
      });
  }

  // ================= UI HELPERS =================
  close(): void {
    this.showRejectPopUp = false;
    this.cartPopUp = false;
  }

  toInt(val: any): number {
    return parseInt(val, 10);
  }

  // ================= NAVIGATION =================
  byPet(petId: any): void {
    this.router.navigate(['/bypet'], {
      queryParams: { petId }
    });
  }
}
